const resourceData = [
  {
    title: 'Pages.xyz',
    category: 'Design Inspiration',
    link: 'https://www.pages.xyz/',
  },
  {
    title: 'Laws of UX',
    category: 'Design Principles',
    link: 'https://lawsofux.com/',
  },
  {
    title: 'UISources',
    category: 'Design Inspiration',
    link: 'https://www.uisources.com/',
  },
  {
    title: 'Undraw',
    category: 'Free Illustrations',
    link: 'https://undraw.co/',
  },
  {
    title: 'Refactoring UI',
    category: 'Design Tips',
    link: 'https://refactoringui.com/',
  },
  {
    title: 'Color.co',
    category: 'Color Inspiration',
    link: 'http://mattsaling.com/colors/',
  },
]

export default resourceData
